import React, { useState } from "react";
import { Button, ErrorMsg, Grid, Label, Toastify } from "atoms";

import { FormInput } from "molecules";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { useAuth } from "contexts/Auth";

const validationSchema = Yup.object().shape({
  oldPassword: Yup.string().required("Password is required"),
  newPassword: Yup.string()
    .required("Password is required")
    .min(7, "Password too short")
    .max(20, "Password too long")
    .matches(/^(?=.*[a-z])/, "Must contain at least one lowercase character")
    .matches(/^(?=.*[A-Z])/, "Must contain at least one uppercase character")
    .matches(/^(?=.*[0-9])/, "Must contain at least one number")
    .matches(
      /^(?=.*[!@#$%^&*?~`])/,
      "Must contain at least one special character"
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords don't match")
    .required("Password is required"),
});

export const ProfileChnagePasswordForm = () => {
  const {
    actions: { changePassword },
  } = useAuth();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const onSubmit = (values, formikBag) => {
    setLoading(true);
    changePassword(values)
      ?.then(() => {
        Toastify("success", "Password updated successfully");

        formikBag?.resetForm();
      })
      .catch((e) => {
        setError(e?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Formik
      initialValues={{ oldPassword: "", newPassword: "", confirmPassword: "" }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ dirty, setFieldValue }) => {
        return (
          <Form>
            <Grid gridRowGap="2.4rem" mt="1.8rem" pr="12rem">
              <Grid gridRowGap="1.6rem">
                <Label text="Old Password" />
                <FormInput
                  name="oldPassword"
                  type="password"
                  placeholder=" Old Password"
                  onChange={(e) => {
                    setFieldValue("oldPassword", e?.target?.value);
                    error && setError("");
                  }}
                />
              </Grid>
              <Grid gridRowGap="1.6rem">
                <Label text="New Password" />
                <FormInput
                  name="newPassword"
                  type="password"
                  placeholder="New Password"
                  onChange={(e) => {
                    setFieldValue("newPassword", e?.target?.value);
                    error && setError("");
                  }}
                />
              </Grid>
              <Grid gridRowGap="1.6rem">
                <Label text="Confirm Password" />
                <FormInput
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                  onChange={(e) => {
                    setFieldValue("confirmPassword", e?.target?.value);
                    error && setError("");
                  }}
                />
              </Grid>

              {error && <ErrorMsg text={error} />}

              <Button
                variant={dirty === true ? "primary" : "disabled"}
                loading={loading}
                type="submit"
                height={{ xs: "4.3rem", lg: "4.8rem" }}
                width="fit-content"
                px="3rem"
              >
                Save Changes
              </Button>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};
